import React from 'react';
import PropTypes from 'prop-types';

import ColorPickerInput from '../../common/ColorPickerInput';

const ColorPicker = ({ color, setColor }) => (
  <div>
    <h3 className="c-heading c-heading--tiny u-mb-">Color</h3>
    <ColorPickerInput value={color} onChange={setColor} />
  </div>
);

ColorPicker.propTypes = {
  color: PropTypes.string,
  setColor: PropTypes.func,
};
ColorPicker.defaultProps = {
  color: '',
  setColor: () => null,
};

export default ColorPicker;
